import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const white = ui.white[700];
const greyDark = ui.neutral[700];
const greyLight = ui.neutral[100];

const { textMObj } = typographyStyles;

export const headerWrapperCss = {
  alignItems: "center",
  background: white,
  borderBottom: `1px solid ${greyLight}`,
  display: "flex",
  height: "58px",
  justifyContent: "center",
  marginBottom: "8px",
  position: "sticky",
  top: 0,
  zIndex: 1,
};

export const headerCss = {
  ...textMObj,
  color: greyDark,
  fontWeight: "bold",
  margin: 0,
};

export const buttonWrapperCss = {
  color: greyDark,
  left: "8px",
  position: "absolute",
};

export const buttonIconCss = {
  path: {
    strokeWidth: 2,
  },
};
